import { FC, memo } from 'react';

import { SelectProps } from './types';
import { StyledCreatableSelect, StyledSelect } from './styled';

const Component: FC<SelectProps> = memo<SelectProps>((props) => {
    const {
        disabled = false,
        required = false,
        value = '',
        isMulti = false,
        searchable = true,
        backgroundColor,
        textColor,
        options = [],
        isCreatable = false,
        onCreateOption,
        ...restProps
    } = props;

    const SelectComponent = isCreatable ? StyledCreatableSelect : StyledSelect;

    return (
        <SelectComponent
            className={'w-100'}
            classNamePrefix="styled"
            isDisabled={disabled}
            isSearchable={searchable}
            required={required}
            value={value}
            isMulti={isMulti}
            options={options}
            $background={backgroundColor}
            $text={textColor}
            onCreateOption={onCreateOption}
            {...(restProps as any)}
        />
    );
});
Component.displayName = 'Select';

export const CustomSelect: FC<SelectProps> = Object.assign(Component, {});
